import React, { useEffect, useMemo, useState } from "react";
import {
  formatToTwoDecimalPlaces,
} from "helper/Functions";
import UserService from "service/UserService";
import SectionLoader from "components/ui/loaders/SectionLoader";
import { API_URL } from "helper/Constants";
import { ReactComponent as IconSearch } from "assets/icons/icon-search.svg";
import { ReactComponent as IconTransfer } from "assets/icons/icon-action-transfer.svg";
import { ReactComponent as IconReport } from "assets/icons/icon-action-report.svg";
import { ReactComponent as IconChangePassword } from "assets/icons/icon-action-change-password.svg";
import CustomTable from "components/ui/tables/CustomTable";
import { toast } from "react-toastify";
import { useAuth } from "provider/AuthContext";
import { useTranslation } from "react-i18next";
import ManageUserChangePassword from "./OnlineUserChangePassword";
import ChangePasswordPage from "pages/auth/ChangePasswordPage";
import { useNavigate } from "react-router-dom";
import Auth from "service/AuthService";
import SelectDropDown from "components/ui/forms/SelectDropDown";

const OnlineUser = () => {
  const userService = new UserService(API_URL);
  const authServ = new Auth(API_URL);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");
  const [allUsersBalance, setAllUsersBalance] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortCriteria, setSortCriteria] = useState("alphabetically");
  const [userName, setUserName] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [openCurrentUserChangePasswordModal, setOpenCurrentUserChangePasswordModal] = useState(false);
  const [userIdForPasswordUpdate, setUserIdForPasswordUpdate] = useState("");

  const fetchUsers = async (inputValue, callback) => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }
    try {
      let response;
      let options = [];
      if (user.role === "Owner") {
        response = await authServ.getAllUsers();
        console.log(response.users);
        let OnlineUsers = response.users.filter((user) => user.registrationType === "online");
        console.log(OnlineUsers, "OnlineUsers")
        options = OnlineUsers?.filter((fi) => fi.username !== user.username && fi.username.toLowerCase().includes(inputValue.toLowerCase()))
          ?.map((item) => ({
            value: item._id,
            label: `${item.username}  `,
          }));
      }
      console.log(options, "options")
      callback(options);
      //console.log("Fetched users full response:", response);
    } catch (error) {
      console.error("Error fetching users:", error);
      callback([]);

      // Handle token expiration or invalid token (401)
      if (error.response?.status === 401) {
        toast.error("Authorization failed. Please log in again.");
      } else {
        toast.error("Error fetching users. Please try again later.");
      }
    }
  };
  const handleInputChange = (value) => {
    setSearchTerm(value);
    if (value.length >= 3) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };
  const handleMenuClose = () => {
    setShowSuggestions(false);
  };
  useEffect(() => {
    if (!user || user.role !== "Owner") {
      navigate(-1);
      toast.error("You don't have permission to access this page");
    }
    // Only run when component mounts or user changes
  }, [user, navigate]);
  const fetchUserBalance = async () => {
    setLoading(true);

    try {
      console.log(selectedUser?.label, "selectedUser");

      const queryParams = {};
      const onlineUserName = selectedUser?.label || "";

      console.log(onlineUserName, "...");

      if (onlineUserName) queryParams.username = onlineUserName;
      if (userId) queryParams.userId = userId;

      // Check if both are empty
      // if (!onlineUserName && !userId) {
      //   toast.error("Please enter either Username or User ID");
      //   setLoading(false);
      //   return;
      // }

      // Call API with query parameters
      const data = await userService.getOnlineUserBalance(queryParams);

      const formattedData = Array.isArray(data) ? data : [data];
      setAllUsersBalance(formattedData);
      setLoading(false);
    } catch (error) {
      setResponseMsg(error.message || "Failed to fetch user data");
      console.error("Error fetching users:", error);
      toast.error("Error fetching user data");
      setLoading(false);
    }
  };


  const handleSearch = () => {
    fetchUserBalance();
  };

  const handleReset = () => {
    setUserName("");
    setUserId("");
    setAllUsersBalance([]);
    setResponseMsg("");
  };

  // Sort users if there are any
  const sortedUsers = useMemo(() => {
    if (!allUsersBalance || !allUsersBalance.length) return [];

    return [...allUsersBalance].sort((a, b) => {
      if (sortCriteria === "alphabetically") {
        return a.name.localeCompare(b.name);
      }
      if (sortCriteria === "balance") {
        return b.balance - a.balance;
      }
      return 0;
    });
  }, [allUsersBalance, sortCriteria]);

  const tableData = sortedUsers;

  const totalUsers = sortedUsers.length;
  const totalBal = sortedUsers.reduce((acc, row) => acc + row.balance, 0);
  const totalNetworkBal = sortedUsers.reduce(
    (acc, row) => acc + row.networkBalance,
    0
  );

  const tableColumns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "User",
        size: 150,
        Cell: ({ cell }) => (
          <div className="flex items-center gap-2">
            {/* {cell.row.original.createdBy && (
              <span className="flex items-center gap-2">
                {cell.row.original.createdBy}
                <span className="text-gray-700 -mt-0.5 text-2xl leading-3 font-mono font-lighter">
                  →
                </span>
              </span>
            )} */}
            {cell.row.original?.name}
          </div>
        ),
        Footer: () => <>Total ({totalUsers} players)</>,
      },
      {
        accessorKey: "role",
        header: "Role",
        size: 80,
      },
      {
        accessorKey: "balance",
        header: "Balance",
        size: 50,
        Cell: ({ cell }) => (
          <div className="flex">
            <>
              {formatToTwoDecimalPlaces(
                cell.row.original.balance ? cell.row.original.balance : 0
              )}{" "}
              {user?.currency}
            </>
          </div>
        ),
        Footer: () => (
          <>
            {formatToTwoDecimalPlaces(totalBal)} {user?.currency}
          </>
        ),
      },
      {
        accessorKey: "networkBalance",
        header: "Network Balance",
        size: 50,
        Cell: ({ cell }) => (
          <>
            {formatToTwoDecimalPlaces(
              cell.row.original?.networkBalance
                ? cell.row.original?.networkBalance
                : 0
            )}{" "}
            {user?.currency}
          </>
        ),
        Footer: () => (
          <>
            {formatToTwoDecimalPlaces(totalNetworkBal)} {user?.currency}
          </>
        ),
      },
      {
        accessorKey: "#",
        header: "Actions",
        size: 50,
        Cell: ({ cell }) => (
          <div className="flex space-x-1">
            <span className="cursor-pointer text-nowrap flex flex-1 justify-center items-center gap-1 hover:bg-[#f2c41a] text-md text-[#242424] focus:outline-none rounded-lg bg-white border border-black mx-1 max-w-40 w-full py-1">
              <IconTransfer />
              <span>Transfer</span>
            </span>
            <span className="cursor-pointer text-nowrap flex flex-1 justify-center items-center gap-1 hover:bg-[#f2c41a] focus:outline-none rounded-lg bg-white border border-black mx-1 max-w-40 w-full py-1">
              <IconReport />
              <span>Report</span>
            </span>
            <span
              className="cursor-pointer text-nowrap flex flex-1 justify-center items-center gap-1 hover:bg-[#f2c41a] focus:outline-none rounded-lg bg-white border border-black mx-1 max-w-60 w-full py-1"
              onClick={() => {

                setOpenChangePasswordModal(true);
                setUserIdForPasswordUpdate(cell.row.original.id);
              }}
            >
              <IconChangePassword />
              <span>{t("Change Password")}</span>
            </span>
          </div>
        ),
      },
    ],
    [totalBal, totalNetworkBal, totalUsers, t, user]
  );

  return (
    <div className="flex flex-col w-full">
      <header className="rounded-lg bg-[#474747] text-white w-full p-3">
        <h1 className="md:text-2xl text-lg font-bold md:text-left text-center">
          Manage Online Users
        </h1>
      </header>

      {/* Search Fields */}
      <div className="flex flex-col md:flex-row gap-3 mt-5">
        <div className="w-full md:w-1/3">
          {/* <label className="block text-md ml-3 text-[#242424]">User Name</label> */}
          <SelectDropDown
            label="Choose User"
            placeholder={"Type 3+ letters"}
            selectedOption={selectedUser ? selectedUser : []}
            loadOptions={fetchUsers}
            handleChange={(option) => setSelectedUser(option)}
            inputValue={searchTerm || ""}
            onInputChange={(value) => handleInputChange(value)}
            menuIsOpen={showSuggestions || false}
            onMenuClose={() => handleMenuClose()}
            isSearchable={true}
          />
        </div>
        <div className="w-full md:w-1/3">
          <label className="block text-md ml-3 text-[#242424]">User ID</label>
          <input
            name="userId"
            id="userId"
            autoComplete="off"
            data-1p-ignore="true"
            className="text-black w-full rounded-md border px-2 mt-[0.4px] py-1.5"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col md:flex-row items-center gap-3 mt-5">
        <button
          className="bg-[#f2c41a] hover:bg-[#f2c41a]/80 text-black w-full md:w-36 font-bold py-2 rounded-lg"
          type="button"
          onClick={handleSearch}
        >
          SEARCH
        </button>
        <button
          className="text-center border border-black w-full md:w-36 rounded-lg text-md hover:bg-gray-300 text-gray-700 font-bold py-2 px-4"
          type="reset"
          onClick={handleReset}
        >
          RESET
        </button>
        <button
          type="button"
          className="flex justify-center items-center gap-1 w-full md:w-auto md:ml-auto text-primary border border-primary [&_svg_path]:fill-primary [&_svg]:w-6 [&_svg]:h-6 rounded-lg text-md hover:bg-gray-300 text-gray-700 font-bold py-2 px-3"
          onClick={() => setOpenCurrentUserChangePasswordModal(true)}
        >
          <IconChangePassword />
          <span>{t("Change Password")}</span>
        </button>
      </div>

      <hr className="border-t mt-5 mb-3 border-[#d4c8c8a3]" />

      {/* Results Section */}
      {loading ? (
        <div className="flex justify-center py-8">
          <SectionLoader bgColor="light" />
        </div>
      ) : (
        <>
          {allUsersBalance && allUsersBalance.length ? (
            <>
              {/* Sorting Options */}
              <div className="mb-4 flex items-center">
                <span className="text-sm text-black">Sort by:</span>
                <div className="flex ml-2">
                  <label htmlFor="sortByUser" className="space-x-2 pr-3">
                    <input
                      type="radio"
                      name="sortCriteria"
                      id="sortByUser"
                      value="alphabetically"
                      checked={sortCriteria === "alphabetically"}
                      onChange={(e) => setSortCriteria(e.target.value)}
                    />
                    <span className="text-black font-bold">Alphabetically</span>
                  </label>
                  <label htmlFor="sortByBalance" className="space-x-2">
                    <input
                      type="radio"
                      name="sortCriteria"
                      id="sortByBalance"
                      value="balance"
                      checked={sortCriteria === "balance"}
                      onChange={(e) => setSortCriteria(e.target.value)}
                    />
                    <span className="text-black font-bold">Balance</span>
                  </label>
                </div>
              </div>

              {/* Results Table */}
              <CustomTable
                enableStickyFooter
                columns={tableColumns}
                data={tableData}
                enableGlobalFilter={true}
                enableFilterMatchHighlighting={true}
              />
            </>
          ) : (
            <div className="flex flex-col items-center justify-center py-6 px-3 my-7">
              <div className="bg-[#EDEEF5] rounded-lg p-6 sm:p-8 [&_svg_path]:fill-slate-500">
                <IconSearch />
              </div>
              <span className="text-lg sm:text-xl mt-8 mb-4 text-[#474747] text-center w-full max-w-[300px]">
                {responseMsg || "Enter a Username or User ID to search"}
              </span>
            </div>
          )}
        </>
      )}

      {/* Modals */}
      {openChangePasswordModal && (
        <ManageUserChangePassword
          isOpen={openChangePasswordModal}
          onClose={() => setOpenChangePasswordModal(false)}
          userIdForPasswordUpdate={userIdForPasswordUpdate}
          setUserIdForPasswordUpdate={setUserIdForPasswordUpdate}
        />
      )}

      {openCurrentUserChangePasswordModal && (
        <ChangePasswordPage
          isOpen={openCurrentUserChangePasswordModal}
          onClose={() => setOpenCurrentUserChangePasswordModal(false)}
        />
      )}
    </div>
  );
};

export default OnlineUser;